import React from "react";
import SpreadsheetDropzone from "./SpreadsheetDropzone";

// The sample writes a real roster into a workspace: offered to visitors and demo accounts, not to
// an operator signed in to their own company (they have their own file to upload).
const StartHero = ({ onFile, onSample, busy, error, authenticated, isDemo, onSkipDashboard }) => {
  const showSample = !authenticated || isDemo;
  return (
    <section className="start-hero">
      <div className="start-hero__copy">
        <p className="start-kicker">Transportation command</p>
        <h1>
          Your spreadsheet.
          <span> A smarter way to move.</span>
        </h1>
        <p className="start-lede">
          Turn your existing student list into optimized routes, connected drivers, and live tracking.
        </p>
        <ol className="start-steps-inline">
          <li>We interpret the roster from whatever columns you have</li>
          <li>You confirm students, parents, gaps, and vehicle capacity</li>
          <li>Routes, drivers, and parent apps come into view</li>
        </ol>
        <SpreadsheetDropzone onFile={onFile} disabled={busy} error={error} busy={busy} />
        <div className="start-hero__actions">
          {showSample && (
            <button type="button" className="start-btn" onClick={onSample} disabled={busy}>
              Try our sample
            </button>
          )}
          {authenticated && onSkipDashboard && (
            <button type="button" className="start-text-link" onClick={onSkipDashboard}>
              Skip to dashboard
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default StartHero;
